import React from 'react';
import { DefaultTheme } from 'styled-components';
import { Select } from 'antd';
import { defineMessage, FormattedMessage, MessageDescriptor } from 'react-intl';
import { ReportType } from 'utils/apiClient/services/reports/types';

const reportTypes: Array<[ReportType, MessageDescriptor]> = [
  [ReportType.Daily, defineMessage({ defaultMessage: 'Daily' })],
  [ReportType.Weekly, defineMessage({ defaultMessage: 'Weekly' })],
  [ReportType.Monthly, defineMessage({ defaultMessage: 'Monthly' })],
];

const { Option } = Select;

type Props = {
  theme?: DefaultTheme;
  defaultValue?: ReportType;
  value: ReportType;
  handleChange: (type: ReportType) => void;
};

const TipReportTypeSelect: React.FC<Props> = ({ value, handleChange }) => (
  <Select<ReportType>
    dropdownMatchSelectWidth={false}
    value={value}
    onChange={(v) => handleChange(v)}
    css={`
      margin-right: 10px;
    `}
  >
    {reportTypes.map(([v, label]) => (
      <Option key={v} value={v}>
        <FormattedMessage {...label} />
      </Option>
    ))}
  </Select>
);

export default TipReportTypeSelect;
